/**
 * The version a status poll is about, out of a station's versions list.
 *
 * Its own `version_id` first: every version of a file shares its name, so
 * matching on either picked the newest same-named version and reported ITS
 * status. File name next, for a poll that only knows the upload's name; else
 * the first version listed. `null` when the list is empty.
 */
export function findPolledVersion(versions: readonly any[], submissionId: string, fileName: string): any | null {
  if (versions.length === 0) return null;
  return versions.find(v => v?.version_id === submissionId)
    || versions.find(v => v?.file_name === fileName)
    || versions[0];
}

/** A finished remodelling run. Hyphen and underscore both occur, and REMODELLING with two Ls — all treated alike. */
export function isRemodelingCompleted(status: unknown): boolean {
  return /^REMODELL?ING_COMPLETED$/.test(String(status ?? '').trim().toUpperCase().replace(/-/g, '_'));
}
